const galleryId = '#product-media-gallery';
const thumbsId = '#product-media-gallery-thumbs';

var thumbs = new Swiper(thumbsId, {
  spaceBetween: 10,
  freeMode: true,
  watchSlidesProgress: true,
  direction: 'horizontal',
  slidesPerView: 'auto',
  breakpoints: {
    768: {
      direction: 'vertical',
    },
  },
});

var gallery = new Swiper(galleryId, {
  spaceBetween: 10,
  slidesPerView: 1,
  direction: 'horizontal',
  breakpoints: {
    768: {
      direction: 'vertical',
    },
  },
  thumbs: {
    swiper: thumbs,
  },
});
